import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// NM 2024 theme
import Nm2024Theme from '../../nm2024Theme/colors';

// eslint-disable-next-line import/prefer-default-export
export const LinkNm2024 = styled(Link)`
  ${({ theme, themeType, variant }) => {
    let thisBgColor = 'transparent';
    let thisBgColorHover = 'transparent';
    let thisBgColorActive = 'transparent';
    let thisColor = Nm2024Theme.link.lightTheme;

    if(variant === 'buttonLinkPrimary'){
      if(themeType === 'darkTheme'){
        thisBgColor =  Nm2024Theme.cta.darkTheme;
        thisBgColorHover = Nm2024Theme.cta.darkThemeHover;
        thisBgColorActive = Nm2024Theme.cta.darkThemeActive;
        thisColor = Nm2024Theme.navy.navy;
      }else{
        thisBgColor = Nm2024Theme.cta.lightTheme;
        thisBgColorHover = Nm2024Theme.cta.lightThemeHover;
        thisBgColorActive = Nm2024Theme.cta.lightThemeActive;
        thisColor = theme.colors.neutral.white;
      }
    }

    return css`
      && {
        color: ${thisColor};
        border-color: ${thisBgColor};
        border-radius: ${rem(30)};
        background-color: ${thisBgColor};
        font-family: 'Source Sans', 'Helvetica Neue', Helvetica, sans-serif;
        font-weight: 600;
        &:hover {
          background-color: ${thisBgColorHover};
          border-color: ${thisBgColorHover};
        }
        &:active {
          background-color: ${thisBgColorActive};
          border-color: ${thisBgColorActive};
        }
      }
    `;
  }
}`;
